import React, { useContext, useId, useRef } from "react";
import "./Confirm.css";
import { Context } from "../../context/Context";
import { translations } from "../../utils/lang";
import { Button } from "../ui";
import { useModalLayer, useSubmitGuard } from "./modalHooks";

export const ConfirmModal = ({
  title,
  message,
  app,
  confirmText,
  cancelText,
  tone,
  onConfirm,
  onCancel,
}) => {
  const { lang } = useContext(Context);
  const titleId = useId();
  const dialogRef = useRef(null);
  // If onConfirm returns a promise, repeat clicks are ignored until it settles.
  const [busy, runConfirm] = useSubmitGuard();

  useModalLayer(true, {
    containerRef: dialogRef,
    onEscape: () => {
      if (!busy) onCancel?.();
    },
  });

  return (
    <div className="confirm-container">
      <div
        ref={dialogRef}
        className={`confirm ${tone ? `confirm-${tone}` : ""}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-busy={busy || undefined}
        tabIndex={-1}
      >
        <div className="confirm-content">
          <h4 id={titleId}>{title || translations[lang].deleteModal.areyousure}</h4>

          {app && <p style={{ whiteSpace: "pre-line" }}>{app}</p>}

          {message && <p style={{ whiteSpace: "pre-line" }}>{message}</p>}
        </div>

        <div className="confirm-btn">
          <Button
            variant="primary"
            appearance="filled"
            onClick={() => runConfirm(onConfirm)}
            disabled={busy}
            loading={busy}
          >
            {confirmText || translations[lang].deleteModal.yes}
          </Button>
        </div>

        <div className="cancel-confirm-btn">
          <Button
            variant="danger"
            appearance="soft"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelText || translations[lang].deleteModal.no}
          </Button>
        </div>
      </div>
    </div>
  );
};
